import { TrialProsperiLookingFor } from '@/pages/payment/components/purchase/components/purchase-promo/components/trial-prosperi-modal/helpers/type/type';
import { I18n } from '@/services/i18n';

type Message = {
  tryNow: string;
  lookingFor: {
    [key in TrialProsperiLookingFor]: string;
  };
  expiresIn: string;
  welcome: string;
  her: string;
  his: string;
  him: string;
  men: string;
  women: string;
  personalOffer: string;
  li1: string;
  li2: string;
  li3: string;
  try7days: string;
  trial1: string;
  trial2: string;
  trial3: string;
  like1: string;
  like2: string;
  like3: string;
  like4: string;
  like5: string;

  message1: string;
  message2: string;
  message3: string;
  message4: string;
  message5: string;

  lookingForSomething: string;
  yourAge: string;
  only: string;
};

const messages: I18n<Message> = {
  en: {
    tryNow: 'TRY NOW',
    lookingFor: {
      serious: 'Serious',
      romantic: 'Romantic',
      flirty: 'Flirty',
      naughty: 'Naughty',
      hookup: 'Hookup',
      relationship: 'Relationship',
      friends: 'Friends',
      skip: 'Casual',
      chatting: 'Chatting',
      general: 'General',
    },
    expiresIn: 'Discount expires in',
    welcome: 'Welcome',
    her: 'her',
    his: 'his',
    him: 'him',
    men: 'men',
    women: 'women',
    personalOffer: 'We have a personal offer <br />for you!',
    li1: 'Appear in top of the search: be the first in line and beat the competition',
    li2: "Don't wait for a match! Message {gender} right away using Power Chat",
    li3: 'Join the 83% who went on a date within the first 10 days with this offer',
    try7days: 'Try MeetMyAge for 7 days, <br />and you will:',
    trial1: 'Unlock all {gender} photos and access premium search filters',
    trial2: 'Capture the top spot: rise above other {gender} and be the first in search results',
    trial3: 'Get unlimited messages - engage with {gender} and keep the spark alive',
    like1: "You've run out of likes",
    like2: 'Try MeetMyAge for 7 days, and you will:',
    like3: 'Get unlimited likes: supercharge your chances to find a match',
    like4: 'Unlock all {gender} photos and access premium search filters',
    like5: 'Capture the top spot: rise above other {gender} and be the first in search results',

    message1: "You've run out of messages",
    message2: 'Try MeetMyAge for 7 days, and you will:',
    message3: 'Get unlimited messages - engage with {gender} and keep the spark alive',
    message4: "Uncover when she's thinking of you — get notified when she views your profile",
    message5:
      'Take control: 96% agree that the delete own messages function saved their connection',

    lookingForSomething: 'Looking for something',
    yourAge: 'Your age',
    only: 'only',
  },
  es: {
    tryNow: 'PRUEBA AHORA',
    lookingFor: {
      serious: 'Serio',
      romantic: 'Romántico',
      flirty: 'Coqueto',
      naughty: 'Travieso',
      hookup: 'Encuentro',
      relationship: 'Relación',
      friends: 'Amigos',
      skip: 'Casual',
      chatting: 'Charlando',
      general: 'General',
    },

    expiresIn: 'El descuento expira en',
    welcome: 'Bienvenido',
    her: 'ella',
    his: 'él',
    him: 'él',
    men: 'hombres',
    women: 'mujeres',
    personalOffer: '¡Tenemos una oferta personal <br />para ti!',

    li1: 'Aparece en la parte superior de la búsqueda: ¡sé el primero en la fila y vence a la competencia!',
    li2: ' ¡No esperes a hacer match! Mándale un mensaje a {gender} de inmediato con Power Chat. ',
    li3: 'Únete al 83% que tuvo una cita en los primeros 10 días con esta oferta',

    try7days: 'Prueba MeetMyAge por 7 días, <br />y obtendrás:',

    trial1: 'Descubre todas las fotos de {gender} y accede a filtros de búsqueda premium.',
    trial2:
      'Sé el primero: destaca sobre otros {gender} y aparece en los primeros resultados de búsqueda.',
    trial3: 'Mensajes sin límites: interactúa con {gender} y mantén la llama encendida.',

    like1: 'Te has quedado sin likes',
    like2: 'Prueba MeetMyAge por 7 días, y obtendrás:',
    like3: 'Obtén likes ilimitados: ¡aumenta tus posibilidades de encontrar un match!',
    like4: 'Descubre todas las fotos de {gender} y accede a filtros de búsqueda premium.',
    like5:
      'Sé el primero: destaca sobre otros {gender} y aparece en los primeros resultados de búsqueda.',

    message1: 'Te has quedado sin mensajes',
    message2: 'Prueba MeetMyAge por 7 días, y obtendrás:',
    message3: 'Mensajes sin límites: interactúa con {gender} y mantén la llama encendida.',
    message4: 'Descubre cuándo está pensando en ti: ¡recibe una notificación cuando vea tu perfil!',
    message5:
      'Toma el control: el 96% está de acuerdo en que la función de eliminar mensajes propios salvó su conexión',

    lookingForSomething: 'Buscando algo',
    yourAge: 'Tu edad',
    only: 'solo',
  },
  de: {
    tryNow: 'JETZT AUSPROBIEREN',
    lookingFor: {
      serious: 'Ernst',
      romantic: 'Romantisch',
      flirty: 'Flirty',
      naughty: 'Frech',
      hookup: 'Verabredung',
      relationship: 'Beziehung',
      friends: 'Freunde',
      skip: 'Unverbindlich',
      chatting: 'Plaudern',
      general: 'Allgemein',
    },
    expiresIn: 'Rabatt läuft ab in',
    welcome: 'Willkommen',
    her: 'ihr',
    his: 'seiner',
    him: 'ihn',
    men: 'Männer',
    women: 'Frauen',
    personalOffer: 'Wir haben ein persönliches Angebot <br />für Sie!',
    li1: 'Erscheinen Sie am Anfang der Suche: Seien Sie der Erste und schlagen Sie die Konkurrenz',
    li2: 'Warten Sie nicht auf ein Match! Nachricht an {gender} sofort mit Power Chat senden',
    li3: '85% gingen innerhalb der ersten 10 Tage mit diesem Angebot auf ein Date',
    try7days: 'Probieren Sie MeetMyAge 7 Tage lang,<br />und Sie werden:',
    trial1: 'Alle {gender} Fotos entsperren und Premium-Suchfilter zugreifen',
    trial2:
      'Den obersten Platz erobern: Erheben Sie sich über andere {gender} und seien Sie der Erste in den Suchergebnissen',
    trial3:
      'Erhalten Sie unbegrenzte Nachrichten - engagieren Sie sich mit {gender} und halten Sie die Verbindung aufrecht',
    like1: 'Ihnen gehen die Likes aus',
    like2: 'Probieren Sie MeetMyAge 7 Tage lang aus, und Sie werden:',
    like3: 'Unbegrenzte Likes erhalten: Steigern Sie Ihre Chancen, ein Match zu finden',
    like4: 'Alle {gender} Fotos entsperren und Premium-Suchfilter zugreifen',
    like5:
      'Den obersten Platz erobern: Erheben Sie sich über andere {gender} und seien Sie der Erste in den Suchergebnissen',

    message1: 'Ihnen gehen die Nachrichten aus',
    message2: 'Probieren Sie MeetMyAge 7 Tage lang aus, und Sie werden:',
    message3:
      'Erhalten Sie unbegrenzte Nachrichten - engagieren Sie sich mit {gender} und halten Sie die Verbindung aufrecht',
    message4:
      'Erfahren Sie, wann sie an Sie denkt - erhalten Sie eine Benachrichtigung, wenn sie Ihr Profil ansieht',
    message5:
      'Übernehmen Sie die Kontrolle: 96% stimmen zu, dass die Funktion "Eigene Nachrichten löschen" ihre Verbindung gerettet hat',

    lookingForSomething: 'Suchen Sie nach etwas',
    yourAge: 'Ihr Alter',
    only: 'nur',
  },
};

export { messages };
